import fetch from '../api/fetch'

/**
 * 	Action to fetch users list
 *
 *  @param     {string} URL [/api/v1/users]
 *  @param     {number} page []
 *  @param     {number} perPage [Number of results per page]
 *  @param     {string} sortedBy [The parameter to filter the results. eg. id, fullName, ...]
 *  @param     {string} sortedType [Order to filter the parameters: 'asc' or 'desc']
 * 	@method GET
 */

export function fetchUsers(
    page: number = 1,
    perPage: number = 30,
    sortedBy: string = 'fullName',
    sortedType: string = 'asc'
) {

    let params = `?page=${page}&perPage=${perPage}&sortedBy=${sortedBy}&sortedType=${sortedType}`

    return {
        type: 'FETCH_USERS',
        payload: fetch(`/users${params}`, { method: 'GET' }),
    }
}

export function loadMoreUsersList(
    page: number = 1,
    perPage: number = 30,
    sortedBy: string = 'fullName',
    sortedType: string = 'asc'
) {

    let params = `?page=${page}&perPage=${perPage}&sortedBy=${sortedBy}&sortedType=${sortedType}`

    return {
        type: 'FETCH_USERS_APPEND',
        payload: fetch(`/users${params}`, { method: 'GET' }),
    }
}

/**
 * 	Action to get User details
 *
 * 	@param 	{String} URL [/api/v1/users]
 * 	@param 	{Object} user [Object with new user details]
 * 	@method GET
 */
export function getUserDetail(user: object) {
    return {
        type: 'FETCH_USER_AGENCY_DETAIL',
        payload: fetch(`/users/${user}`, { method: 'GET' }),
    }
}

/**
 * 	Action to Add new user
 *
 * 	@param 	{String} URL [/api/v1/users]
 * 	@param 	{Object} user [Object with new user details]
 * 	@method POST
 */
export function addNewUser(user: object) {
    return {
        type: 'ADD_NEWUSER',
        payload: fetch('/users', { method: 'POST', body: user }),
    }
}

/**
 * 	Action to Deactivate user
 *
 * 	@param 	{String} URL [/api/v1/users]
 * 	@param 	{Object} user [Object with new user details]
 * 	@method POST
 */
export function deactivateUser(userId: number, toUserId: number) {
    return {
        type: 'DEACTIVATE_USER',
        payload: fetch(`/users/${userId}?to=${toUserId}`, { method: 'DELETE' }),
    }
}

export function changeUserTypeAgency(userId: number, details: object) {
    return {
        type: 'CHANGE_ACCOUNT_TYPE',
        payload: fetch(`/users/change_type/${userId}`, { method: 'POST', body: details }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/users.ts